import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Main } from 'foundations-components/transitional/components/Main';
import { PageHeading } from 'foundations-components/transitional/components/PageHeading';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useEffect } from 'react';
import { NavMarker } from 'react-rhumb';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import { SCREENS } from '../constants/tracking/Screens';
import { HorizontalFreeCard } from '../hsoc/HorizontalFreeCard';
import { trackPageView } from '../utils/tracking/trackingEventUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const HubSpotOnCreditsPage = () => {
  const screen = SCREENS.DEFAULT;
  useDocumentTitle(screen);
  useEffect(() => {
    trackPageView({
      screen
    });
  }, [screen]);
  return /*#__PURE__*/_jsx("div", {
    "data-selenium-id": "page-success",
    children: /*#__PURE__*/_jsx(NavMarker, {
      name: "HUBSPOT_ON_CREDITS_PAGE",
      children: /*#__PURE__*/_jsxs(Main, {
        paddingInline: "0",
        children: [/*#__PURE__*/_jsxs(View, {
          marginBlock: "1400",
          children: [/*#__PURE__*/_jsx(PageHeading, {
            marginBlockEnd: "200",
            display: "inline-block",
            typography: "display-100",
            textAlign: "center",
            justifyContent: "center",
            inlineSize: "100%",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-pages-ui.pagesV2.default.pageTitle"
            })
          }), /*#__PURE__*/_jsx(Text, {
            as: "p",
            typography: "body-500",
            marginBlockStart: "500",
            textAlign: "center",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-pages-ui.pagesV2.default.description"
            })
          })]
        }), /*#__PURE__*/_jsx("section", {
          children: /*#__PURE__*/_jsx(HorizontalFreeCard, {})
        })]
      })
    })
  });
};